import * as React from 'react';
import {
  tokens,
  Button,
  Input,
  Title3,
  makeStyles,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  title: {
    textAlign: 'center',
    marginBottom: tokens.spacingVerticalM,
  },
  input: {
    width: '100%',
  },
  errorText: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeBase300,
    marginTop: tokens.spacingVerticalXXS,
    marginBottom: tokens.spacingVerticalS,
  },
  button: {
    width: '100%',
    marginTop: tokens.spacingVerticalM,
  },
  errorMessage: {
    color: tokens.colorPaletteRedForeground1,
    textAlign: 'center',
    marginTop: tokens.spacingVerticalS,
  },
  linkContainer: {
    textAlign: 'center',
    marginTop: tokens.spacingVerticalM,
  },
  link: {
    display: 'block',
    marginBottom: tokens.spacingVerticalS,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorBrandForeground1,
    textDecoration: 'none',
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  linkLast: {
    display: 'block',
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorBrandForeground1,
    textDecoration: 'none',
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },
});

interface LoginFormProps {
  getFieldProps: (field: string) => any;
  errors: Record<string, string>;
  loginLoading: boolean;
  loginError: string | null;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onToggleMode: () => void;
  onForgotPassword: () => void;
  onEmailBlur?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  getFieldProps,
  errors,
  loginLoading,
  loginError,
  onSubmit,
  onToggleMode,
  onForgotPassword,
  onEmailBlur,
}) => {
  const styles = useStyles();

  return (
    <form onSubmit={onSubmit} className={styles.form}>
      <Title3 className={styles.title}>
        Acesse a sua conta
      </Title3>

      <div>
        <Input
          id="email"
          required
          size="large"
          placeholder="E-mail"
          className={styles.input}
          {...getFieldProps('email')}
          onBlur={(e) => {
            getFieldProps('email').onBlur(e);
            onEmailBlur?.();
          }}
        />
        {errors.email && (
          <div id="email-error" className={styles.errorText}>
            {errors.email}
          </div>
        )}      
      </div>

      <div>
        <Input
          id="password"
          type="password"
          required
          size="large"
          placeholder="Senha"
          className={styles.input}
          {...getFieldProps('password')}
        />
        {errors.password && (
          <div id="password-error" className={styles.errorText}>
            {errors.password}
          </div>
        )}
      </div>

      <Button
        type="submit"
        appearance="primary"
        size="large"
        disabled={loginLoading}
        className={styles.button}
      >
        {loginLoading ? 'Entrando...' : 'ENTRAR'}
      </Button>

      {loginError && (
        <div className={styles.errorMessage}>
          {loginError}
        </div>
      )}

      <div className={styles.linkContainer}>
        <span
          className={styles.link}
          onClick={onForgotPassword}
        >
          Esqueceu a senha? Clique aqui para redefinir.
        </span>
        <span
          className={styles.linkLast}
          onClick={onToggleMode}
        >
          Não tem uma conta? Inscreva-se.
        </span>
      </div>
    </form>
  );
};

export default LoginForm;